// The game's ball physics: one event-driven simulation of the table (physics/solver.ts, physics/table.ts) that
// replaced Box2D. Balls.ts puts balls in it and reads them through a small body object (see Balls.ts), and
// Game.UpdateState advances it by the real time each rendered frame took, so the game runs at the same speed at
// any refresh rate, and a shot ends in the same place however often it is sampled.
import {createTableSimulation} from "./physics/table";
import {MAX_FRAME_SECONDS} from "./physics/constants";
import type {Simulation, SimListener} from "./physics/solver";

let World = {
    sim: null as unknown as Simulation,
    /** performance.now() of the last advance (null: the next frame starts the clock) */
    lastFrame: null as number | null,
    Init() {
        World.sim = createTableSimulation();
        World.lastFrame = null;
    },
    /**
     * Advance the simulation by the real time since the last frame (at most MAX_FRAME_SECONDS), times `speed`
     * (fast-forward, test hooks only). Contacts and pots are reported through the listener as they happen.
     */
    advanceFrame(now: number, speed: number, listener: SimListener) {
        const dt = World.lastFrame === null ? 0 : Math.min(MAX_FRAME_SECONDS, Math.max(0, (now - World.lastFrame) / 1000));
        World.lastFrame = now;
        World.sim.advance(dt * speed, listener);
    },
    /** The game loop isn't advancing the physics (spectating): the next frame mustn't count the time in between. */
    pause() {
        World.lastFrame = null;
    },
};

export default World;
